import {ExamType} from "../models/exam";
import {SectionName} from "../models/section";

export const defaultTestTime: { [key in ExamType]?: { [section in SectionName]?: number } } = {
    toefl: {},
    ielts: {
        listening: 40 * 60,
        reading: 60 * 60,
        writing: 60 * 60 ,
    },
    tcf_fr: {},
    tcf_ca: {},

}